export default {
  data() {
    return {
      presets: [
        {
          id: 1,
          alias: "TODAY",
          alias_preset: "TODAY",
          name: "T",
          default: true,
          presetTab: true
        },
        {
          id: 2,
          alias: "YESTERDAY",
          alias_preset: "YESTERDAY",
          name: "Y",
          default: false,
          presetTab: true
        },
        {
          id: 3,
          alias: "T_WEEK",
          alias_preset: "T_WEEK",
          name: "THIS W",
          default: false,
          presetTab: true
        },
        {
          id: 4,
          alias: "L_WEEK",
          alias_preset: "L_WEEK",
          name: "LAST W",
          default: false,
          presetTab: true
        },
        {
          id: 4,
          alias: "MONTH",
          alias_preset: "MONTH",
          name: "THIS M",
          default: false,
          presetTab: true
        },
        {
          id: 4,
          alias: "LAST_MONTH",
          alias_preset: "LAST_MONTH",
          name: "LAST M",
          default: false,
          presetTab: true
        },

        {
          id: 5,
          alias: null,
          name: "CUSTOM",
          alias_preset: "CUSTOM",
          default: true,
          presetTab: true
        },



      ]
    };
  },

  created() {
    //
    //   const allowedTabs = [
    //     {
    //       id: 6,
    //       name: "STATS",
    //       alias: "STATS",
    //       presetTab: false
    //     }
    //   ];
    //
    //   if (this.CheckUserPermission([1, 2])) {
    //     this.presets = [...this.presets, ...allowedTabs];
    //   }
  }
};
